import Loadable from '../../components/loadable';

const PosDeliveriesReport = Loadable({
  loader: () => import('../../pages/pos/deliveries/deliveries_report'),
});

angular.module('gym').value('PosDeliveriesReport', PosDeliveriesReport);
